import { CatalogState } from '@marketplace-web/domain/catalog-data'

import {
  CatalogAction,
  isCatalogBrandAction,
  isConfigurationAction,
  isDataAction,
  isDtoAction,
  isDynamicFilterAction,
  isFacetedCategoriesAction,
  isFilterAction,
  isGeneralAction,
  isItemsAction,
  isSearchSessionAction,
} from './actionTypes'
import { filterReducer } from './filterReducer'
import { dynamicFiltersReducer } from './dynamicFiltersReducer'
import { dtoReducer } from './dtoReducer'
import { dataReducer } from './dataReducer'
import { configurationReducer } from './configurationReducer'
import { catalogBrandReducer } from './catalogBrandReducer'
import { searchSessionReducer } from './searchSessionReducer'
import { generalReducer } from './generalReducer'
import { itemsReducer } from './itemsReducer'
import { facetedCategoriesReducer } from './facetedCategoriesReducer'

export const catalogReducer = (state: CatalogState, action: CatalogAction): CatalogState => {
  return {
    filters: isFilterAction(action) ? filterReducer(state.filters, action) : state.filters,
    dynamicFilters: isDynamicFilterAction(action)
      ? dynamicFiltersReducer(state.dynamicFilters, action)
      : state.dynamicFilters,
    dtos: isDtoAction(action) ? dtoReducer(state.dtos, action) : state.dtos,
    data: isDataAction(action) ? dataReducer(state.data, action) : state.data,
    configuration: isConfigurationAction(action)
      ? configurationReducer(state.configuration, action)
      : state.configuration,
    catalogBrand: isCatalogBrandAction(action)
      ? catalogBrandReducer(state.catalogBrand, action)
      : state.catalogBrand,
    searchSession: isSearchSessionAction(action)
      ? searchSessionReducer(state.searchSession, action)
      : state.searchSession,
    general: isGeneralAction(action) ? generalReducer(state.general, action) : state.general,
    items: isItemsAction(action) ? itemsReducer(state.items, action) : state.items,
    facetedCategories: isFacetedCategoriesAction(action)
      ? facetedCategoriesReducer(state.facetedCategories, action)
      : state.facetedCategories,
  }
}
